/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/819/interface/api/cat_10982
 */

import { message } from 'ant-design-vue'
import {
  abtest_list_post,
  abtest_modifystatus_post,
  abtest_query_get,
  abtest_save_post
} from 'server/modules/10982' // list
export const abtest_list_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// modifyAbStatus
export const abtest_modifystatus_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_modifystatus_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryAbtest
export const abtest_query_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_query_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// save
export const abtest_save_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_save_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
